import { ContextualEntityChip } from "src/unifiedCopilot/chat/ContextualEntityChip";
import { parseCopilotResourceRef } from "src/unifiedCopilot/chat/contentBlocks";
import { useResourceMentionClick } from "src/unifiedCopilot/chat/useResourceMentionClick";
import { useResourceMentionLabel } from "src/unifiedCopilot/chat/useResourceMentionLabel";
import { isReferenceContextualEntityType } from "src/unifiedCopilot/context/entityDefinitions";

type Props = {
  /** The label the message carried, shown while nothing here names the resource. */
  label: string;
  attrs: Record<string, string>;
  /** Composer surfaces render mentions inertly; transcripts deep-link. */
  navigable?: boolean;
};

export const ContextualEntityChatMention: React.FC<Props> = ({
  label,
  attrs,
  navigable = true,
}) => {
  const ref = parseCopilotResourceRef(attrs.resourceRef);
  const onClick = useResourceMentionClick(navigable ? ref : null);
  const displayName = useResourceMentionLabel(ref, label);
  const dataLoc = attrs.id ? `reference-${attrs.id}` : undefined;
  if (!isReferenceContextualEntityType(attrs.kind)) {
    return <span>{label}</span>;
  }

  return (
    <ContextualEntityChip
      dataLoc={dataLoc}
      entity={{ displayName, type: attrs.kind }}
      maxWidth
      onClick={onClick}
    />
  );
};
